import React from "react";

export const vinicaState = React.createContext();
